import useAuth from "hooks/UseAuth";
import { FormEvent, useState } from "react";
import Geocode from 'react-geocode';
import { Link } from "react-router-dom";

import { Header } from "shared/components/organisms/Header/Header";
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar";
import { ProfileImage } from "shared/components/organisms/ProfileImage/ProfileImage";
import { AddressModal } from "shared/components/organisms/AddressModal/AddressModal";

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'

import { phoneFormat } from "utils/format";
import { HandleInputChange } from "./utils/HandleInputChange";

import api from "services/api";

import { IAddressData } from "pages/SendingDocuments/interfaces";
import { IProfileFormData } from "./interfaces";

import {
  Container, Content, MapPointerIcon, Section, Subheader
} from "./_personalProfile";
import { IconButton } from "shared/components/atoms/IconButton/IconButton";
import { toast } from "react-toastify";
import { NotificationModal } from "shared/components/organisms/NotificationModal/NotificationModal";

export const PersonalProfile = () => {
  const { user, setUser } = useAuth();

  const [userName] = useState(user?.individual_person?.name || '');
  const [phoneNumber] = useState(() => {
    const state_code = user?.user_phones[0]?.state_code || '';
    const number = user?.user_phones[0]?.number || '';

    const phone = state_code + number;

    if (phone) {
      return phoneFormat(phone);
    }

    return '';
  })
  const [phoneId] = useState(() => {
    const id = user?.user_phones[0]?.id

    if(id){
      return id;
    }

    return '';
  });

  const [showAddressModal, setShowAddressModal] = useState(false)
  const [showNotificationModal, setShowNotificationModal] = useState(false)

  const [profileFormData, setProfileFormData] = useState({} as IProfileFormData)
  const [addressFormData, setAddressFormData] = useState(() => {
    if (user?.addresses?.length > 0) {
      return {...user?.addresses[0] } as IAddressData
    }

    return {} as IAddressData
  })

  const handleFormSUbmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if(!profileFormData?.name
        && !profileFormData?.cellphone
        && addressFormData === user?.addresses[0]
    ){
      return;
    }

    try {
      if(profileFormData?.name){
        await api.put('/users', {
          name: profileFormData?.name
        })

        setUser(prevState => ({
          ...prevState,
          individual_person: {
            ...prevState.individual_person,
            name: profileFormData?.name
          }
        }))
      }

      if(profileFormData?.cellphone){
        const [stringStateCode, number] = profileFormData?.cellphone
          .split(' ')

        const state_code = stringStateCode
          .replace('(', '')
          .replace(')', '')

        await api.put(`/users/phones/${phoneId}`, {
          country_code: "+55",
          state_code,
          number
        })

        setUser((prevState) => {
          const newState = {...prevState}

          newState.user_phones[0].state_code = state_code
          newState.user_phones[0].number = number

          return newState
        })
      }

      if(addressFormData && addressFormData !== user?.addresses[1] && user?.addresses?.length > 0){
        const {
          id: addressId, created_at, geolocation, time_zone, updated_at, user_id, main, city_id, complement, ...rest
        } = addressFormData;

        const AddressFormData = {
          ...rest,
          complement: complement || ' ',
          name: `${addressFormData.street}, ${addressFormData.number} ${addressFormData.complement.length > 0 ? `, complemento ${addressFormData.complement}`: ''} - ${addressFormData.cep}`
        } as IAddressData

        await api.put(`/addresses/${user.addresses[0].id}`, { ...AddressFormData, is_deleted: undefined, city_ibge_code: addressFormData.city_ibge_code })

        setUser(prevState => {
          const newState = {...prevState}
          newState.addresses[0] = {...AddressFormData, id: user.addresses[0].id}

          return newState
        })
      }

      setShowNotificationModal(true)
    } catch (error: any) {
      toast.error(error?.response?.data?.message || error?.toString());

    }
  }

  return (
    <Container>
      <Header />
      <Sidebar />
      <Subheader>
        <Link to="/perfil" className="personal-profile__subheader-button">
          <LeftArrow
            className="personal-profile__subheader-icon"
          />
        </Link>
      </Subheader>

      <Content>
        <ProfileImage />
        <Section>
          <h1 className="personal-profile__section__title">
            Meus dados pessoais
          </h1>
          <form
            className="personal-profile__section__form"
            onSubmit={handleFormSUbmit}
          >
            <div className="personal-profile__section__form-input-wrapper">
              <label
                className="personal-profile__section__form-label"
                htmlFor="personalProfileName"
              >
                Nome
              </label>
              <input
                className="personal-profile__section__form-input"
                id="personalProfileName"
                type="text"
                name="name"
                value={profileFormData?.name}
                defaultValue={userName}
                onChange={(event) => HandleInputChange({
                  event,
                  setState: setProfileFormData
                })}
              />
            </div>
            <div className="personal-profile__section__form-input-wrapper">
              <label
                className="personal-profile__section__form-label"
                htmlFor="personalProfileCellphone"
              >
                Celular
              </label>
              <input
                className="personal-profile__section__form-input"
                id="personalProfileCellphone"
                type="text"
                name="cellphone"
                defaultValue={phoneNumber}
                value={profileFormData?.cellphone}
                onChange={(event) => HandleInputChange({
                  event,
                  setState: setProfileFormData
                })}
              />
            </div>
            {user?.addresses?.length > 0 && (
              <div className="personal-profile__section__form-input-wrapper">
                <label
                  className="personal-profile__section__form-label"
                >
                  Endereço
                </label>
                <input
                  className="personal-profile__section__form-input-readonly"
                  type="text"
                  value={addressFormData?.street}
                  readOnly
                />
                <IconButton
                  type="button"
                  icon={<MapPointerIcon />}
                  fullWidth
                  onClick={() => setShowAddressModal(prevState => !prevState)}
                >
                  Inserir localização
                </IconButton>
              </div>
            )}
            <button
              type="submit"
              className="personal-profile__section__form-button"
            >
              Salvar alteração
            </button>
          </form>
          {showAddressModal && (
            <AddressModal
              setState={setAddressFormData}
              toggleModal={setShowAddressModal}
            />
          )}
          {showNotificationModal && (
            <NotificationModal
              toggleModal={setShowNotificationModal}
              success
            />
          )}
        </Section>
      </Content>
    </Container>
  );
};
